import * as types from '../actions/ActionTypes.js';

const INITIAL_STATE = {
    entity: {
        messageText: '',
        messageType: null,
        pageNotFound: false,
        pageForbidden: false
    }
};

const setPageMessage = (state, action) => {
    return {
        entity: {
            ...state.entity,
            messageText: action.messageText,
            messageType: action.messageType,
            messageView: action.messageView
        }
    };
};

const setPageStatus = (state, action) => {
    if (action.status === 403) {
        return {
            entity: {
                ...state.entity,
                pageForbidden: true
            }
        };
    } else {
        return {
            entity: {
                ...state.entity,
                pageNotFound: true
            }
        };
    }
};

const removePageMessage = () => INITIAL_STATE;

const handlers = {
    [types.SET_PAGE_MESSAGE]: setPageMessage,
    [types.REMOVE_PAGE_MESSAGE]: removePageMessage,
    [types.SET_PAGE_STATUS]: setPageStatus
};

export const getPageMessages = (state) => {
    return state.pageMessages.entity;
};

export default function pageMessages(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) return state;
    return handler(state, action);
}
